import { State } from './abstractions';
import { App, AppVersion } from '@/graphql-schema';

function setApps(state: State, data: { apps: App[] }) {
    if (state == null) { return }

    state.apps = data.apps;
}

function setAppVersions(state: State, data: { appVersions: AppVersion[] }) {
    if (state == null) { return }

    state.appVersions = data.appVersions;
}

function setAppVersionSummary(state: State, data: { appVersionSummary: AppVersion }) {
    if (state == null) { return }

    state.appVersionSummary = data.appVersionSummary;
}

export const mutations = {
    setApps,
    setAppVersions,
    setAppVersionSummary
}